














import { Component, Vue } from "vue-property-decorator";
import ApplicationNavbar from "@/components/ApplicationNavbar.vue";
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import ModalSessionNotice from "@/components/ModalSessionNotice.vue";
import ApplicationSnackbar from "@/components/ApplicationSnackbar.vue";

@Component({
  name: "ApplicationLayout",
  components: { ApplicationNavbar, ApplicationSnackbar, NavigationDrawer, ModalSessionNotice }
})
export default class ApplicationLayout extends Vue {
  // ===== Store ===== //

  // ===== Props ===== //

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //

  // ===== Lifecycle Hooks ===== //
}
